/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Adr_TitleInputs */

const en_options_adr_title = /** @type {(inputs: Options_Adr_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ADR Setup & Configuration`)
};

const fr_options_adr_title = /** @type {(inputs: Options_Adr_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Configuration ADR`)
};

const de_options_adr_title = /** @type {(inputs: Options_Adr_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ADR-Einrichtung und -Konfiguration`)
};

const it_options_adr_title = /** @type {(inputs: Options_Adr_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Configurazione e impostazione ADR`)
};

const ru_options_adr_title = /** @type {(inputs: Options_Adr_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Настройка и конфигурация ADR`)
};

const es_options_adr_title = /** @type {(inputs: Options_Adr_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Configuración y configuración de ADR`)
};

const zh_cn2_options_adr_title = /** @type {(inputs: Options_Adr_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ADR 设置和配置`)
};

const ja_options_adr_title = /** @type {(inputs: Options_Adr_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ADRのセットアップと構成`)
};

const hi_options_adr_title = /** @type {(inputs: Options_Adr_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`एडीआर सेटअप और कॉन्फ़िगरेशन`)
};

const pt_pt2_options_adr_title = /** @type {(inputs: Options_Adr_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Configuração e instalação do ADR`)
};

/**
* | output |
* | --- |
* | "ADR Setup & Configuration" |
*
* @param {Options_Adr_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_adr_title = /** @type {((inputs?: Options_Adr_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Adr_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_options_adr_title(inputs)
	if (locale === "de") return de_options_adr_title(inputs)
	if (locale === "it") return it_options_adr_title(inputs)
	if (locale === "ru") return ru_options_adr_title(inputs)
	if (locale === "es") return es_options_adr_title(inputs)
	if (locale === "zh-CN") return zh_cn2_options_adr_title(inputs)
	if (locale === "ja") return ja_options_adr_title(inputs)
	if (locale === "hi") return hi_options_adr_title(inputs)
	if (locale === "pt-PT") return pt_pt2_options_adr_title(inputs)
	return en_options_adr_title(inputs)
});